export default __webpack_public_path__ + "static/media/hk-the-enclave-the-silveri-hong-kong-mgallery.f9431a75.jpg";